import { createSlice } from "@reduxjs/toolkit"
import { stateEnum } from "../constants/enum.js"

const { userMaster } = stateEnum

const initialState = {
  selectedUser: {},
  detailParams: {},
  isNewEntry: false
}

const userMasterSlice = createSlice({
  name: userMaster,
  initialState,
  reducers: {
    resetUserMaster: (state) => {
      state.selectedUser = {}
    },
    setCurrentUser: (state, action) => {
      state.selectedUser = action.payload
    },
    setDetailParams: (state, action) => {
      state.detailParams = action.payload
    },
    resetDetail: (state) => {
      state.detailParams = {};
      state.isNewEntry = true;
    },
    setIsNewEntry:(state,action)=>{
      state.isNewEntry=action.payload
    }
  },
})

export const { resetUserMaster, setCurrentUser, setDetailParams, resetDetail,setIsNewEntry } = userMasterSlice.actions
export default userMasterSlice.reducer
